import { trpc } from '@/lib/trpc';

const useGetPublicWishes = (public_uid: string) => {
	const { data, isLoading } = trpc.wish.getPublic.useQuery(
		{ public_uid },
		{ enabled: !!public_uid }
	);

	return { wishes: data?.wishes, wishesLoading: isLoading };
};

export default useGetPublicWishes;
